import { map } from '../map'
import createRoute from '../utils/createRoute'
import { routes } from '../utils/data/routes'
import { airports } from '../utils/data/airports'
import renderResultList from '../result-list'
import { infoBoxes, clearInfoBoxes, closeInfoBox } from '../utils/infoBox'
import { openRoute, setOpenRoute, toMarker, setToMarker, fromMarkers, setFromMarkers } from '../markers'
import removeLoader from '../utils/loader/removeLoader'

export const bindAction = item => {
  window.loadedFromUrl = true

  setFromMarkers([])

  // route is now opened
  setOpenRoute(true)

  // clear all infoBoxes
  for (let i = 0; i < infoBoxes.length; i++) {
    closeInfoBox(infoBoxes[i])
  }
  clearInfoBoxes()

  // destination point IATA
  const toIATA = (typeof item === 'string') ? item : $(item).attr('data-to-iata')

  // get new bounderies pbject
  const bounds = new google.maps.LatLngBounds()

  // get toMarker
  const toMarker = airports.filter(airport => airport.iata === toIATA ? true : false)[0]
  toMarker.position = new google.maps.LatLng(toMarker.x, toMarker.y) // have to create new position property

  // get all routes leading to toMarker (clicked marker)
  const currentRoutes = routes.filter(route => route.to === toMarker.iata ? true : false)

  // TODO: rewrite to filter() method
  // sort only markers (airports) that leading to toMarker (clicked marker), no duplicated
  const departures = []
  for (let i = 0; i < airports.length; i++) {
    for (let j = 0; j < currentRoutes.length; j++) {
      if(airports[i].id === currentRoutes[j].fromId) {
        if(departures.length === 0) {
          departures.push(airports[i])
        } else {
          let inArray = false
          for (let k = 0; k < departures.length; k++) {
            if(departures[k].id === airports[i].id)
              inArray = true
          }

          if(!inArray)
            departures.push(airports[i])
        }
      }
    }
  }

  setFromMarkers(departures)

  renderResultList(currentRoutes)

  createRoute(toMarker, fromMarkers, bounds)

  // zoom map to visible points (opened routes)
  map.fitBounds(bounds)

  removeLoader()
}

export default bindAction



// WEBPACK FOOTER //
// ./app/offers/bindAction.js